// src/sidepanel-skeleton.tsx
import { Divider, Skeleton } from "@mui/material";
import { Flex } from "@clara/ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var SidePanelRow = () => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Flex, { width: "100%", p: 1, children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 24 }) }),
    /* @__PURE__ */ jsx(Divider, {})
  ] });
};
var SidepanelSkeleton = (props) => {
  return /* @__PURE__ */ jsxs(Flex, { width: "100%", direction: "column", children: [
    /* @__PURE__ */ jsxs(Flex, { direction: "row", width: "100%", mb: 2, children: [
      /* @__PURE__ */ jsx(Flex, { mr: 2, children: /* @__PURE__ */ jsx(Skeleton, { variant: "circular", width: 72, height: 72 }) }),
      /* @__PURE__ */ jsx(Flex, { sx: { width: `calc(100% - 72px)` }, children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 40 }) })
    ] }),
    /* @__PURE__ */ jsx(Flex, { mb: 4, width: "100%", children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 40 }) }),
    /* @__PURE__ */ jsx(SidePanelRow, {}),
    /* @__PURE__ */ jsx(SidePanelRow, {}),
    /* @__PURE__ */ jsx(SidePanelRow, {}),
    /* @__PURE__ */ jsx(SidePanelRow, {}),
    /* @__PURE__ */ jsx(SidePanelRow, {})
  ] });
};
var SidepanelSkeletonImage = (props) => {
  return /* @__PURE__ */ jsxs(Flex, { width: "100%", direction: "column", children: [
    /* @__PURE__ */ jsx(Flex, { mb: 4, width: "100%", justify: "center", children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 160, width: 284 }) }),
    /* @__PURE__ */ jsx(Flex, { mb: 2, width: "100%", children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 40 }) }),
    /* @__PURE__ */ jsx(Flex, { mb: 2, width: "100%", children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 24 }) }),
    /* @__PURE__ */ jsx(Flex, { mb: 2, width: "100%", children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 24 }) }),
    /* @__PURE__ */ jsx(Flex, { mb: 2, width: "100%", children: /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 24 }) })
  ] });
};

export {
  SidePanelRow,
  SidepanelSkeleton,
  SidepanelSkeletonImage
};
